module.exports = __webpack_public_path__ + "img/Think-Air-2021-White-Long-PNG.b6043458.png";